import React from 'react';

import { dateToPretty } from '@eika-kortbetjening/date-utils';
import { TransactionDetailsKb } from '@eika-kortbetjening/transaction-details';
import { ListPanel } from '@eika/link-panel';
import { Modal } from '@eika/modal';

import { CreditCardMovement, TransactionsService } from '@/domain/account';
import { Format } from '@/domain/app';

import useText from '@hooks/use-text';
import { formatAmount } from '@utils/text-format-utils';

type TransactionDetailModalProps = {
    transaction?: CreditCardMovement;
    onClose(): void;
};

const TransactionDetailModal = ({ transaction, onClose }: TransactionDetailModalProps) => {
    const text = useText();

    if (!transaction) {
        return null;
    }

    const isTransaction = TransactionsService.isTransaction(transaction);

    const label = TransactionsService.isTransaction(transaction) ? transaction.groupDescription ?? '' : '';

    return (
        <Modal id="transaction-details" appNamespace="viewTransaction" shouldCloseOnOverlayClick open setOpen={onClose}>
            <TransactionDetailsKb amount={formatAmount(transaction.postAmount)} label={label}>
                {transaction.cardNumber && (
                    <ListPanel
                        title={text.transactionFrom}
                        textOne={Format.cardNumber(transaction.cardNumber, { maskedNumberReplacement: '*' })}
                    />
                )}
                {transaction.transactionDate && (
                    <ListPanel
                        title={isTransaction ? text.transactionDateLabel : text.transactionsReserved}
                        textOne={dateToPretty(transaction.transactionDate)}
                    />
                )}
                {isTransaction && (
                    <ListPanel title={text.transactionBooked} textOne={dateToPretty(transaction.postDate)} />
                )}
                {isTransaction && transaction.categoryDescription && (
                    <ListPanel title={text.transactionCategory} textOne={transaction.categoryDescription} />
                )}
                {transaction.description && (
                    <ListPanel title={text.transactionMessage} textOne={transaction.description} />
                )}
                {transaction.id && <ListPanel title={text.transactionReference} textOne={transaction.id} />}
            </TransactionDetailsKb>
        </Modal>
    );
};

export default TransactionDetailModal;
